var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Cash Flow")]),_c('ul',[_c('li',[_vm._v("Projection of cash flow")]),_c('ul',[_c('li',[_vm._v("Need something to record recurring expenses")])]),_c('li',[_vm._v("Future: integration with bank account")])])])
}]

export { render, staticRenderFns }